import React, { useContext, useEffect, useState } from 'react';
import {
  getInstitutions,
  getUsers,
  getAuthorizedPersons,
  getInstitutionsType,
  getInstitutionByTypeId,
  updateAuthorizedPersons,
  deleteAuthorizedPersons,
  getAuthorizedPersonsByInstitutionId,
} from '../../../actions';
import { Context } from '../../../defaults';
import AuthorizedpersonsAdd from './authorizedpersonAdd';
import {
  Tabs,
  TreeSelect,
  Row,
  Col,
  Select,
  Empty,
  Form,
  Input,
  Card,
  Descriptions,
  Popconfirm,
  Tooltip,
  Switch,
  message,
} from 'antd';
import {
  CarryOutTwoTone,
  DeleteTwoTone,
  EditTwoTone,
  CheckOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { groupBy } from '../../../utils';
import './index.css';
import { MaskedInput } from 'antd-mask-input';
import { emailRegex, latinRegex, phoneRegex, studyYearRegex } from '../../../common';

const { TabPane } = Tabs;
const { TreeNode } = TreeSelect;

const AuthorizedPersons = () => {
  const { dictionary, language, setLoading } = useContext(Context);
  const [active, setActive] = useState('1');
  const [added, setAdded] = useState(false);
  const [authorizedPersons, setAuthorizedPersons] = useState();
  const [authorizedPersonsList, setAuthorizedPersonsList] = useState();
  const [institutions, setInstitutions] = useState();
  const [selectedInstitutionType, setSelectedInstitutionType] = useState();
  const [institutionsType, setInstitutionsType] = useState();
  const [groupedInstitutions, setGroupedInstitutions] = useState({});
  const [selectedInstitution, setSelectedInstitution] = useState();
  const [selectedAuhtorizedPersons, setSelectedAuthorizedPersons] = useState();
  const [edit, setEdit] = useState(false);
  const requiredMessage = dictionary?.FillTheField[language];

  const onSelectInstitution = (value) => {
    setSelectedInstitution('')
    setSelectedAuthorizedPersons('')
    if (value) {
      setSelectedInstitution(institutions.filter((x) => x.id === value)[0]);
      getAuthorizedPersonsByInstitutionId(value).then(({ data }) => setAuthorizedPersonsList(data));
    }

  };

  const callback = (key) => {
    setActive(key);
    setAdded(false);
  };

  const filterInstitutionsByTypeId = (id) => {
    setSelectedInstitution('')
    setSelectedAuthorizedPersons('')
    if (id) {
      setLoading(true);
      getInstitutionByTypeId(id).then((res) => {
        setSelectedInstitutionType(id);
        setGroupedInstitutions(groupBy(res.data, 'city'));
        setInstitutions(res.data);
        setLoading(false);
      });
    }

  };

  useEffect(() => {
    getAuthorizedPersons().then(({ data }) => setAuthorizedPersons(data));
    getInstitutions().then(({ data }) => setInstitutions(data));
    getInstitutionsType().then(({ data }) => setInstitutionsType(data));
  }, []);

  const saveEditedAuthorizedPerson = () => {
    if (
      selectedAuhtorizedPersons.lastName &&
      selectedAuhtorizedPersons.firstName &&
      selectedAuhtorizedPersons.phone &&
      selectedAuhtorizedPersons.users.login &&
      selectedAuhtorizedPersons.users.email &&
      selectedAuhtorizedPersons.institutionId &&
      selectedAuhtorizedPersons.studyYear
    ) {
      setEdit(false);
      updateAuthorizedPersons(selectedAuhtorizedPersons)
        .then((res) => {
          filterInstitutionsByTypeId(selectedInstitutionType);
          getAuthorizedPersonsByInstitutionId(
            selectedAuhtorizedPersons.institutionId,
          ).then(({ data }) => setAuthorizedPersonsList(data));
          message.success(dictionary?.SuccessfullyChanged[language]);
        })
        .catch((errors) => {
          if (!!errors.response.data.errors) {
            message.error(errors.response.data.errors.Login, 4);
          } else {
            message.error(dictionary?.SomethingWentWrong[language], 4);
          }
          setLoading(false);
        });
    } else {
      message.error(dictionary?.FillTheAllRequiredFields[language]);
    }
  };

  const onInputChange = ({ target }) => {
    const { name, value } = target;
    setSelectedAuthorizedPersons({ ...selectedAuhtorizedPersons, [name]: value });
  };

  const onChange = ({ name, value, target }) => {
    if (name === 'active') {
      setSelectedAuthorizedPersons({ ...selectedAuhtorizedPersons, users: { ...selectedAuhtorizedPersons.users, [name]: value ? 1 : 0 }, });
    } else if (!!target && (target.name === 'login' || target.name === 'email')) {
      setSelectedAuthorizedPersons({
        ...selectedAuhtorizedPersons,
        users: { ...selectedAuhtorizedPersons.users, [target.name]: target.value },
      });
    } else {
      setSelectedAuthorizedPersons({ ...selectedAuhtorizedPersons, [name]: value });
    }
  };

  const confirm = () => {
    deleteAuthorizedPersons(selectedAuhtorizedPersons.id).then((res) => {
      message.success(dictionary?.OperationSuccessful[language]);
      setSelectedInstitution(null);
      setSelectedAuthorizedPersons(null);
      filterInstitutionsByTypeId(selectedInstitutionType);
    });
  };

  const rules = (value, fieldName = null) => {
    if (fieldName === 'login') {
      if (!selectedAuhtorizedPersons.users.login.match(latinRegex)) {
        return { validateStatus: 'error', help: dictionary?.OnlyLatinAndNumber[language] };
      } else {
        return { validateStatus: 'success', help: null };
      }
    } else if (fieldName === 'email') {
      if (!selectedAuhtorizedPersons.users.email.match(emailRegex)) {
        return { validateStatus: 'error', help: dictionary?.InvalidEmail[language] };
      } else {
        return { validateStatus: 'success', help: null };
      }
    } else if (fieldName === 'phone') {
      if (!selectedAuhtorizedPersons.phone.match(phoneRegex)) {
        return { validateStatus: 'error', help: dictionary?.InvalidPhone[language] };
      } else {
        return { validateStatus: 'success', help: null };
      }
    } else {
      if (!value) return { validateStatus: 'error', help: requiredMessage };
      else return { validateStatus: 'success', help: null };
    }
  };

  function rulesForStudyYear(e) {
    if (!!e) {
      const value = e;
      const years = value.split('/');
      if (years[0] > years[1]) {
        return {
          validateStatus: 'error',
          help: dictionary?.StudyYearFromLessThanTo[language],
        };
      }
      if (
        Number.isInteger(parseInt(years[0])) &&
        Number.isInteger(parseInt(years[1])) &&
        years[1] - years[0] !== 1
      ) {
        return {
          validateStatus: 'error',
          help: dictionary?.StudyYearValidate[language],
        };
      }
      if (!value.match(studyYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
      }
      if (!!value) {
        return { validateStatus: 'success', help: null };
      }
    } else {
      return { validateStatus: 'error', help: requiredMessage };
    }
  }

  return (
    <Tabs defaultActiveKey="1" activeKey={active} onChange={callback}>
      <TabPane tab={`${dictionary?.AddAuthorizedPersons[language]}`} key="1">
        <AuthorizedpersonsAdd
          setAdded={setAdded}
          setActive={setActive}
          authorizedPersons={authorizedPersons}
          institutionsId={institutions}
        />
      </TabPane>
      <TabPane tab={dictionary?.AuthorizedPersonsList[language]} key="2">
        <Row style={{ marginTop: '30px' }} gutter={16}>
          <Col span={8}>
            <Select
              placeholder={dictionary?.InstitutionType[language]}
              size="large"
              style={{ width: '100%' }}
              allowClear={true}
              onChange={(value) => filterInstitutionsByTypeId(value)}>
              {institutionsType &&
                institutionsType.map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {el.name}
                    </Select.Option>
                  );
                })}
            </Select>
          </Col>
          <Col span={8}>
            <TreeSelect
              showSearch
              style={{ width: '100%' }}
              size="large"
              disabled={!selectedInstitutionType}
              value={selectedInstitution?.id}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder={dictionary?.SelectInstitutionOrSearch[language]}
              allowClear
              treeDefaultExpandAll
              onChange={onSelectInstitution}
              filterTreeNode={(search, item) => {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
              }}>
              {groupedInstitutions &&
                Object.keys(groupedInstitutions).map((key) => {
                  return (
                    <TreeNode title={key} key={`city${key}`} disabled>
                      {groupedInstitutions[key].map((value) => {
                        return <TreeNode value={value.id} title={value.name} key={value.id} />;
                      })}
                    </TreeNode>
                  );
                })}
            </TreeSelect>
          </Col>
          <Col span={8}>
            <Select
              placeholder={dictionary?.AuthorizedPersons[language]}
              size="large"
              style={{ width: '100%' }}
              allowClear={true}
              disabled={!selectedInstitution}
              value={selectedAuhtorizedPersons?.id}
              filterOption={(search, item) => {
                return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
              }}
              onChange={(value) =>
                value ?
                  setSelectedAuthorizedPersons(authorizedPersonsList.find((i) => i.id === value))
                  :
                  setSelectedAuthorizedPersons('')
              }>
              {authorizedPersonsList &&
                authorizedPersonsList.map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {`${el.lastName} ${el.firstName} ${el.middleName}`}
                    </Select.Option>
                  );
                })}
            </Select>
          </Col>
        </Row>
        {!selectedInstitution && <Empty style={{ marginTop: '100px' }} />}
        {selectedAuhtorizedPersons && (
          <Card
            style={{ marginTop: '30px' }}
            actions={[
              <Tooltip placement="top" title={dictionary?.Delete[language]}>
                <Popconfirm
                  placement="bottom"
                  title={dictionary?.AreYouSureToDelete[language]}
                  onConfirm={confirm}
                  okText={dictionary?.Yes[language]}
                  cancelText={dictionary?.No[language]}>
                  <DeleteTwoTone key="delete" twoToneColor="#eb2f96" />
                </Popconfirm>
              </Tooltip>,
              <Tooltip placement="top" title={dictionary?.Edit[language]}>
                {!edit && <EditTwoTone key="edit" onClick={() => setEdit(true)} />}
                {edit && <CarryOutTwoTone key="edit" onClick={saveEditedAuthorizedPerson} />}
              </Tooltip>,
            ]}>
            <Descriptions
              size="default"
              title={dictionary?.EditAuthorizedPersons[language]}
              bordered
              column={12}>
              <Descriptions.Item label={dictionary?.UserLogin[language]} span={12}>
                {/* {edit && (
                  <Form.Item hasFeedback {...rules(selectedAuhtorizedPersons.users.login, 'login')}>
                    <TextArea
                      style={{ width: '100%' }}
                      maxLength={100}
                      showCount={true}
                      size="middle"
                      name="login"
                      onChange={onChange}
                      value={selectedAuhtorizedPersons.users.login}
                      placeholder={dictionary?.UserLogin[language]}
                    />
                  </Form.Item>
                )} */}
                {
                  // !edit && 
                  !!selectedAuhtorizedPersons && selectedAuhtorizedPersons.users.login
                }
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.Email[language]} span={12}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedAuhtorizedPersons.users.email, 'email')}>
                    <TextArea
                      style={{ width: '100%' }}
                      size="middle"
                      name="email"
                      onChange={onChange}
                      maxLength={100}
                      value={selectedAuhtorizedPersons.users.email}
                      showCount={true}
                      placeholder={dictionary?.Email[language]}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedAuhtorizedPersons && selectedAuhtorizedPersons.users.email}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.Institution[language]} span={6}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedAuhtorizedPersons.institutionId)}>
                    <Select
                      style={{ width: '100%' }}
                      placeholder={dictionary?.Institution[language]}
                      name="institutionId"
                      onChange={(value) => onChange({ name: 'institutionId', value })}
                      size="middle"
                      value={selectedAuhtorizedPersons.institutionId}
                      allowClear={true}>
                      {institutions &&
                        institutions.map((el) => {
                          return (
                            <Select.Option value={el.id} key={el.id}>
                              {`${el.name}, ${el.city}, ${el.address}`}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                )}
                {!edit &&
                  !!selectedAuhtorizedPersons &&
                  !!institutions &&
                  institutions.find((i) => i.id === selectedAuhtorizedPersons.institutionId).name}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.YearStudy[language]} span={6}>
                {edit && (
                  <Form.Item
                    hasFeedback
                    {...rulesForStudyYear(selectedAuhtorizedPersons.studyYear)}>
                    <MaskedInput
                      name="studyYear"
                      style={{ width: '100%' }}
                      mask="11/11"
                      size="middle"
                      placeholder="xx/xx"
                      onChange={onInputChange}
                      value={selectedAuhtorizedPersons.studyYear}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedAuhtorizedPersons && selectedAuhtorizedPersons.studyYear}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.LastName[language]} span={6}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedAuhtorizedPersons.lastName)}>
                    <TextArea
                      style={{ width: '100%' }}
                      size="middle"
                      name="lastName"
                      onChange={onInputChange}
                      maxLength={100}
                      value={selectedAuhtorizedPersons.lastName}
                      showCount={true}
                      placeholder={dictionary?.LastName[language]}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedAuhtorizedPersons && selectedAuhtorizedPersons.lastName}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.FirstName[language]} span={6}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedAuhtorizedPersons.firstName)}>
                    <TextArea
                      style={{ width: '100%' }}
                      size="middle"
                      name="firstName"
                      onChange={onInputChange}
                      maxLength={100}
                      value={selectedAuhtorizedPersons.firstName}
                      showCount={true}
                      placeholder={dictionary?.FirstName[language]}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedAuhtorizedPersons && selectedAuhtorizedPersons.firstName}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.MiddleName[language]} span={6}>
                {edit && (
                  <Form.Item hasFeedback>
                    <Input
                      style={{ width: '100%' }}
                      name="middleName"
                      onChange={onInputChange}
                      size="middle"
                      value={selectedAuhtorizedPersons.middleName}
                      placeholder={dictionary?.MiddleName[language]}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedAuhtorizedPersons && selectedAuhtorizedPersons.middleName}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.Phone[language]} span={6}>
                {edit && (
                  <Form.Item hasFeedback {...rules(selectedAuhtorizedPersons.phone, 'phone')}>
                    <MaskedInput
                      mask="+7 (111) 111-11-11"
                      placeholder="+7 (___) ___-__-__"
                      name="phone"
                      style={{ width: '100%' }}
                      size="middle"
                      onChange={onInputChange}
                      value={selectedAuhtorizedPersons.phone}
                    />
                  </Form.Item>
                )}
                {!edit && !!selectedAuhtorizedPersons && selectedAuhtorizedPersons.phone}
              </Descriptions.Item>
              <Descriptions.Item label={dictionary?.IsActive[language]} span={6}>
                <Switch
                  disabled={!edit}
                  checked={!!selectedAuhtorizedPersons && selectedAuhtorizedPersons.users.active === 1}
                  name="active"
                  onChange={(value) => onChange({ name: 'active', value })}
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                />
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )}
      </TabPane>
    </Tabs>
  );
};

export default AuthorizedPersons;
